import { BarChart3 } from "lucide-react";
import { motion } from "framer-motion";
import { useState,useEffect } from "react";
import { useTheme } from "../context/ThemeContext";

import FlowAnalytics from "../components/FlowAnalytics";
import PredictiveAnalytics from "../components/PredictiveAnalytics";
import AnomalyDetection from "../components/AnomalyDetection";
import { useLocation } from "react-router-dom";

export default function Analytics({ onBack }) {
  const { colors } = useTheme();
  // const [activeMainTab, setActiveMainTab] = useState(onBack?.tab || "flow");
  // const [anomalyCategory, setAnomalyCategory] = useState(onBack?.category || "");
  // const [anomalyStartDate, setAnomalyStartDate] = useState(onBack?.startDate || "");
  // const [anomalyEndDate, setAnomalyEndDate] = useState(onBack?.endDate || "");
  const location = useLocation();
  const navData = location.state;
  const [activeMainTab, setActiveMainTab] = useState(navData?.tab || "flow");
  const [anomalyCategory, setAnomalyCategory] = useState(navData?.category || "");
  const [anomalyStartDate, setAnomalyStartDate] = useState(navData?.startDate || "");
  const [anomalyEndDate, setAnomalyEndDate] = useState(navData?.endDate || "");
  const [anomalyTimeRange, setAnomalyTimeRange] = useState(navData?.timeRange || "last_90_days");

  // 🔹 FLOW STATES
  const [dateRange, setDateRange] = useState("Past 30 Days");
  const [interval, setInterval] = useState("1 Weeks");
  // const [system, setSystem] = useState("Plant");
  const [system, setSystem] = useState(navData?.system || "total");
  const [activeSubTab, setActiveSubTab] = useState("accountability");
  const [demandCategory, setDemandCategory] = useState("all");

  // 🔹 PREDICTIVE STATES
  const [predictiveSystem, setPredictiveSystem] = useState("Total");

  // 🔹 ANOMALY STATES
  // const [anomalyCategory, setAnomalyCategory] = useState("City of Houston");
  // const [anomalyStartDate, setAnomalyStartDate] = useState("");
  // const [anomalyEndDate, setAnomalyEndDate] = useState("");
  const [selectedAnomaly, setSelectedAnomaly] = useState("129308");

  const anomalyMeters = [
    {
      id: "129308",
      category: "Potable Domestic",
      date: "Jan 20, 2026",
      gallons: "24,411",
    },
    {
      id: "181133",
      category: "Potable Domestic",
      date: "Jan 21, 2026",
      gallons: "22,925.9",
    },
    {
      id: "112465",
      category: "Potable Domestic",
      date: "Jan 22, 2026",
      gallons: "1,489",
    },
    {
      id: "177615",
      category: "Potable Domestic",
      date: "Jan 20, 2026",
      gallons: "430",
    },
  ];

  const generateAnomalyChartData = () => {
    const data = [
      { date: "20 Jan", gallons: 20000, meterId: "129308" },
      { date: "20 Jan", gallons: 18500, meterId: null },
      { date: "21 Jan", gallons: 15000, meterId: null },
      { date: "21 Jan", gallons: 12000, meterId: null },
      { date: "22 Jan", gallons: 8000, meterId: null },
      { date: "22 Jan", gallons: 5000, meterId: null },
      { date: "22 Jan", gallons: 2000, meterId: null },
    ];
    return data;
  };

  const anomalyChartData = generateAnomalyChartData();
  useEffect(() => {
    if (navData?.tab === "anomaly") {
      setActiveMainTab("anomaly");
      if (navData.category) setAnomalyCategory(navData.category);
      if (navData.system) setSystem(navData.system);
      if (navData.startDate) setAnomalyStartDate(navData.startDate);
      if (navData.endDate) setAnomalyEndDate(navData.endDate);
      if (navData.timeRange) setAnomalyTimeRange(navData.timeRange);
    }
  }, [navData]);

  return (
    <div
      className="flex-1"
      style={{ backgroundColor: colors.background }}
    >
      {/* HEADER */}
      <motion.div
        className="mb-4 md:mb-6"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1
          className="text-3xl font-bold text-transparent bg-clip-text"
          style={{
            backgroundImage: colors.gradient,
            WebkitTextFillColor: "transparent",
            WebkitBackgroundClip: "text",
          }}
        >
          Analytics
        </h1>
        <p
          className="text-xs sm:text-sm mt-1"
          style={{ color: colors.textSecondary }}
        >
          Monitor and analyze system performance patterns
        </p>
      </motion.div>

     <motion.div
  className="flex gap-3 mb-6 flex-wrap"
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5, delay: 0.1 }}
>
  {[
    { key: "flow", label: "Flow Analytics" },
    { key: "predictive", label: "Predictive Analytics" },
    { key: "anomaly", label: "Anomaly Detection" },
  ].map((tab) => (
    <button
      key={tab.key}
      onClick={() => setActiveMainTab(tab.key)}
      className="flex items-center gap-2 px-4 py-2.5 rounded-lg border transition-all duration-300 relative overflow-hidden group"
      style={{
        background:
          activeMainTab === tab.key
            ? `${colors.primary}20`
            : colors.cardBg,
        borderColor:
          activeMainTab === tab.key
            ? colors.primary
            : colors.border,
        boxShadow:
          activeMainTab === tab.key
            ? `0 0 20px ${colors.primary}40`
            : "none",
      }}
    >
      {activeMainTab === tab.key && (
        <motion.div
          className="absolute inset-0"
          style={{
            background: `linear-gradient(to right, transparent, ${colors.primary}30, transparent)`,
          }}
          animate={{ x: ["-100%", "200%"] }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        />
      )}

      <BarChart3
        className="w-4 h-4 relative z-10"
        style={{
          color:
            activeMainTab === tab.key
              ? colors.primary
              : colors.textSecondary,
        }}
      />

      <span
        className="text-sm font-semibold relative z-10"
        style={{
          color:
            activeMainTab === tab.key
              ? colors.text
              : colors.textSecondary,
        }}
      >
        {tab.label}
      </span>
    </button>
  ))}
</motion.div>
      {/* CHILD COMPONENTS */}
      {activeMainTab === "flow" && (
        <FlowAnalytics
          dateRange={dateRange}
          setDateRange={setDateRange}
          interval={interval}
          setInterval={setInterval}
          system={system}
          setSystem={setSystem}
          activeSubTab={activeSubTab}
          setActiveSubTab={setActiveSubTab}
          demandCategory={demandCategory}
          setDemandCategory={setDemandCategory}
        />
      )}

      {activeMainTab === "predictive" && (
        <PredictiveAnalytics
          predictiveSystem={predictiveSystem}
          setPredictiveSystem={setPredictiveSystem}
        />
      )}

      {activeMainTab === "anomaly" && (
        // <AnomalyDetection
        //   anomalyCategory={anomalyCategory}
        //   setAnomalyCategory={setAnomalyCategory}
        //   anomalyStartDate={anomalyStartDate}
        //   setAnomalyStartDate={setAnomalyStartDate}
        //   anomalyEndDate={anomalyEndDate}
        //   setAnomalyEndDate={setAnomalyEndDate}
        //   anomalyMeters={anomalyMeters}
        //   selectedAnomaly={selectedAnomaly}
        //   setSelectedAnomaly={setSelectedAnomaly}
        //   anomalyChartData={anomalyChartData}
        // />
        <AnomalyDetection
        initialCategory={anomalyCategory}
        initialStartDate={anomalyStartDate}
        initialEndDate={anomalyEndDate}
        initialTimeRange={anomalyTimeRange}
      />
      )}
    </div>
  );
}
